















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { SeamlessCoreStore } from '@seamless/store';
import VueSeamlessStore from '@seamless/vue-store-plugin';
import { initializeComponentRegistry } from '@owc/component-registry-connection';
import { connectionName as aemEnvConnectionName } from '@owc/connection-aem-environment';

import {
  AUTHENTICATION_CONNECTION,
  AUTHENTICATION_CONNECTION_CIAS,
  AuthConnectionCias,
  AuthState,
  Claims,
  AuthDispatchersCias,
  AuthInitParams,
  JwtIssuers,
  Stages,
  TENANT,
} from '@b2x/login-library';
import { Logger } from '@b2x/common';

import { AemState } from '@/common/interfaces/owc';
import UserFlyout from '@/components/user-flyout.vue';
import { B2XUMComponentConfig, UserMenuConfig } from '@/common/interfaces/common';

@Component({
  name: 'user-menu',
  mixins: [new VueSeamlessStore().mixin],
  components: {
    UserFlyout,
  },
})
export default class App extends Vue {
  store!: SeamlessCoreStore;

  componentRegistry!: any;

  config: UserMenuConfig | null = null;

  languageDirection = 'ltr';

  claims: Claims | null = null;

  isOpen = false;

  ciasDispatchers!: AuthDispatchersCias;

  logger = new Logger('USER_MENU_COMPONENT');

  @Prop()
  componentId!: string;

  beforeCreate(): void {
    this.componentRegistry = initializeComponentRegistry();
  }

  async created(): Promise<void> {
    if (window.top?.aemNamespace) {
      this.logger.log('there is aemNamespace');

      this.componentRegistry.subscribe(this.componentId, this.onComponentConfig);
    } else {
      this.logger.log('there is no aemNamespace');
    }

    await this.bootstrap();
  }

  async bootstrap(): Promise<void> {
    this.logger.log('adding connections');

    await this.store.addConnection(new AuthConnectionCias()).catch(() => {
      this.logger.log('CIAS connection already added');
    });

    this.ciasDispatchers = await this.store.getConnectionDispatchers(AUTHENTICATION_CONNECTION_CIAS);

    this.store.subscribe(AUTHENTICATION_CONNECTION, this.onAuthenticationEvent);
    this.store.subscribe(aemEnvConnectionName, this.onAemEvent);
  }

  mounted(): void {
    document.addEventListener('owc-header-flyout-close', this.onFlyoutClose);
  }

  onComponentConfig(componentConfig: B2XUMComponentConfig): void {
    this.logger.log('component config', componentConfig);

    this.config = componentConfig.payload;
  }

  onAemEvent({ country, language, stage, languageDirection }: AemState): void {
    this.logger.log(`New ${aemEnvConnectionName} event`);

    this.languageDirection = languageDirection || this.languageDirection;

    const authParams: AuthInitParams = {
      tenantId: TENANT.ONEWEB,
      authority: JwtIssuers.CIAS,
      country: country,
      language: language,
      stage: (stage ? stage.toLowerCase() : undefined) as Stages,
    };

    if (stage && country && language) {
      // i18n.locale = `${state.language}_${state.country}`;
      this.logger.log('i18n library locale changed to', `${language}_${country}`);

      this.ciasDispatchers.setInitParams(authParams);
      this.ciasDispatchers.initAuthentication();
    }
  }

  onAuthenticationEvent(state: AuthState): void {
    this.logger.log('New auth event', state);

    this.claims = state.auth.jweIssuer === 'CIAS' ? state.auth.claims : null;
  }

  onToggleMenu(): void {
    this.logger.log('toggle menu');
    this.isOpen = !this.isOpen;
  }

  onFlyoutClose(): void {
    this.isOpen = false;
  }

  beforeDestroy(): void {
    document.removeEventListener('owc-header-flyout-close', this.onFlyoutClose);

    this.store.unsubscribe(aemEnvConnectionName, this.onAemEvent);
    this.store.unsubscribe(this.componentId, this.onComponentConfig);
    this.store.unsubscribe(AUTHENTICATION_CONNECTION, this.onAuthenticationEvent);
  }
}
